import { Util } from './_util.js';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import Swiper from 'swiper/bundle';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

const App = {
  checkTouchDevice: function () {
    if ('ontouchstart' in document.documentElement) {
      $('body').addClass('touch-device');
    } else {
      $('body').addClass('no-touch-device');
    }
  },

  controlAnimation: function () {
    $(window).on('resize', function () {
      $('body').addClass('no-animation');
      setTimeout(function () {
        $('.no-animation').removeClass('no-animation');
      }, 200);
    }).resize();
  },

  checkDevice: function () {
    var device = 'mobile';
    $(window).on('resize', function () {
      var windowWidth = $(window).outerWidth();
      if (windowWidth > 980) {
        if (device == 'mobile') {
					$('.header').removeClass('header--open');
					$('.main-menu').removeClass('main-menu--open');
          $('.main-menu__toggle-btn--close').removeClass('main-menu__toggle-btn--close');
          $('html').removeClass('hidden');
          device = 'desktop';
        }
      } else {
        if (device == 'desktop') {
					$('.main-menu').removeClass('main-menu--open');
          device = 'mobile';
        }
      }
    }).resize();
  },

  controlHeader: function () {
    var prev = 0;

    $(window).on('scroll', function () {
      var scrollTop = $(window).scrollTop(),
        windowHeight = $(window).height(),
        documentHeight = $(document).height();
      if (scrollTop > 0 && scrollTop + windowHeight < documentHeight - 100) {
        $('.header').toggleClass('header--hide', scrollTop > prev);
      }
      prev = scrollTop;
    });
  },

  controlFooter: function () {
    var classes = ['footer__logo--orange', 'footer__logo--blue', 'footer__logo--green', 'footer__logo--yellow'],
        randomClass = classes[Math.floor(Math.random() * classes.length)],
        $target = $('.footer__logo');
    $target.removeClass(classes.join(' '));
    $target.addClass(randomClass);
  },

  controlMainMenu: function () {
    function openMainMenu() {
      $('.header').addClass('header--open');
      $('.main-menu').scrollTop(0);
      $('.main-menu__toggle-btn').addClass('main-menu__toggle-btn--close');
      $('html').addClass('hidden');
      var classes = ['main-menu__wrapper--orange', 'main-menu__wrapper--blue', 'main-menu__wrapper--green', 'main-menu__wrapper--yellow'],
          randomClass = classes[Math.floor(Math.random() * classes.length)],
          $target = $('.main-menu__wrapper');
      $target.removeClass(classes.join(' '));
      $target.addClass(randomClass);
    }

    function closeMainMenu() {
      $('.header').removeClass('header--open');
      $('.main-menu__toggle-btn').removeClass('main-menu__toggle-btn--close');
      $('html').removeClass('hidden');
    }

    $('.main-menu__toggle-btn').on('click',function(){
      if($(this).hasClass('main-menu__toggle-btn--close')){
        closeMainMenu();
      } else {
        openMainMenu();
      }
    });

    $('.no-touch-device .main-menu__link').on('mouseenter mouseleave',function(e){
      let rect = this.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      $(this).find('span').css({ left: x + "px", top: y + "px" });
    });
  },

  controlCTA: function () {
    $('.no-touch-device .cta').on('mouseenter mouseleave',function(e){
      let rect = this.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      $(this).find('.cta__hover').css({ left: x + "px", top: y + "px" });
    });
  },

  controlHero: function () {
    $('.hero-module__scroll-cta').on('click', function (e) {
      e.preventDefault();
      const targetElement = $('.hero-module__content'),
            elementPosition = targetElement.offset().top;
      $('html, body').animate({scrollTop: elementPosition},600,'swing');
    });

    const $videoContainer = $(".no-touch-device .hero-module__imagery");
    const $playButton = $(".no-touch-device .hero-module__play-btn");

    $videoContainer.on("mousemove", function (event) {
      const containerOffset = $videoContainer.offset();
      const containerWidth = $videoContainer.outerWidth();
      const containerHeight = $videoContainer.outerHeight();
      const mouseX = event.pageX - containerOffset.left;
      const mouseY = event.pageY - containerOffset.top;

      const buttonWidth = $playButton.outerWidth();
      const buttonHeight = $playButton.outerHeight();
      const buttonX = mouseX - (buttonWidth / 2);
      const buttonY = mouseY - (buttonHeight / 2);

      const maxButtonX = containerWidth - buttonWidth;
      const maxButtonY = containerHeight - buttonHeight;

      $playButton.css({
        left: Math.min(Math.max(buttonX, 0), maxButtonX) + "px",
        top: Math.min(Math.max(buttonY, 0), maxButtonY) + "px",
        transform: "translate(0,0)",
        transition: "width .4s ease, height .4s ease, background-color .4s ease, transform .4s ease"
      });
    });

    $videoContainer.on("mouseleave", function () {
      setTimeout(function () {
        $playButton.css({
          left: "50%",
          top: "50%",
          transform: "translate(-50%,-50%)",
          transition: "width .4s ease, height .4s ease, top .4s ease, left .4s ease, background-color .4s ease, transform .4s ease"
        });
      }, 50);
    });
  },

  controlAwards: function () {
    function getMaxVisible() {
      const width = $(window).width();
      if (width > 1420) return 6;
      if ((width > 1200) && (width < 1421)) return 5;
      if ((width > 760) && (width < 1201)) return 4;
      if (width < 761) return 3;
    }

    function initializeGrid($module) {
      const $items = $module.find(".awards-module__grid-list-item");
      const $button_group = $module.find(".cta-group");
      const $button = $module.find(".cta--view-more");
      const maxVisible = getMaxVisible();
      let isExpanded = $module.data("expanded") === true;

      if (!isExpanded) {
        $items.each(function (index) {
          $(this).toggleClass("visible", index < maxVisible);
        });
      } else {
        $items.addClass("visible");
      }

      if ($items.length <= maxVisible) {
        $button_group.hide();
      } else {
        $button_group.show();
      }

      $button.find('.cta__text').text(isExpanded ? "- View Less Awards" : "+ View More Awards");
  
      $button.off("click").on("click", function (e) {
        e.preventDefault();
        isExpanded = $module.data("expanded") === true;

        if (isExpanded) {
          $items.each(function (index) {
            $(this).toggleClass("visible", index < maxVisible);
          });
          $button_group.removeClass('active')
          $button.find('.cta__text').text("+ View More Awards");
          $module.data("expanded", false);
          const $scrollTarget = $module.closest('.awards-module__grid-row');
          if ($scrollTarget.length) {
            $('html, body').animate({
              scrollTop: $scrollTarget.offset().top - 150
            }, 400, 'swing');
          }
        } else {
          $items.addClass("visible");
          $button_group.addClass('active')
          $button.find('.cta__text').text("- View Less Awards");
          $module.data("expanded", true);
        }
      });
    }
  
    function setupAllGrids() {
      $(".awards-module__grid-content").each(function () {
        initializeGrid($(this));
      });
    }
  
    setupAllGrids();
  
    let resizeTimeout;
    $(window).on("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(setupAllGrids, 200);
    });
  },

  controlServices: function () {
    $('.services-module__grid-list-item').on('click', function() {
      const content = $(this).find('.description');
      if (content.is(':visible')) {
        content.parent().removeClass('active');
        content.slideUp(400, 'swing');
      } else {
        content.parent().addClass('active');
        content.slideDown(400, 'swing');
      }
    });
  },

  controlWork: function () {
    $('.work-details-module__scroll-cta').on('click', function (e) {
      e.preventDefault();
      const targetElement = $('.work-details-module__content'),
            elementPosition = targetElement.offset().top;
      $('html, body').animate({scrollTop: elementPosition},600,'swing');
    });

    $('.no-touch-device .featured-work-module__item, .no-touch-device .work-grid-module__item').on('mouseenter', function () {
      var color = $(this).data('color');
      $('body, header').css('background-color', color);
    }).on('mouseleave', function () {
      $('body, header').css('background-color', '#FBF8F3');
    });
  },

  filterWork: function () {
    $('.work-grid-module__filter-btn').on('click',function(e){
      e.preventDefault();
      var filter = $(this).attr('data-id');
      if(!$(this).hasClass('work-grid-module__filter-btn--current')) {
        $(this).addClass('work-grid-module__filter-btn--current');
        $('.work-grid-module__filter-btn').not(this).removeClass('work-grid-module__filter-btn--current');
        $('.work-grid-module__item').hide().css('opacity','0');
        $('.work-grid-module__item.' + filter).show();
        setTimeout(function(){
          $('.work-grid-module__item.' + filter).css('opacity','1');
        }, 100);
      }
      if($(this).hasClass('work-grid-module__filter-btn--all')) {
        $('.work-grid-module__item.illustration').show();
        setTimeout(function(){
          $('.work-grid-module__item.illustration').css('opacity','1');
        }, 100);
      }
      $('.work-grid-module__grid').removeClass('all brand digital performance').addClass(filter);
    });
  },

  controlModal: function () {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);

    var youtubePlayer;

    function onYouTubeIframeAPIReady() {
      
    }

    function createYouTubePlayer(videoId) {
      $('#youtube_player_container').html('<div id="youtube_player"></div>');

      youtubePlayer = new YT.Player('youtube_player', {
        height: '390',
        width: '640',
        videoId: videoId,
        playerVars: {
          rel: 0,
          autoplay: 1,
          modestbranding: 1,
        }
      });
    }

    $('a[href="#play-video"]').on('click', function (e) {
      e.preventDefault();
      var videoId = $(this).data('video');

      if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
        createYouTubePlayer(videoId);
      } else {
        var interval = setInterval(function () {
          if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
            clearInterval(interval);
            createYouTubePlayer(videoId);
          }
        }, 100);
      }

      $('html').addClass('hidden');
      $('.modal-module__content').addClass('modal-module__content--open');
      $('.modal-module').addClass('modal-module--open');
    });

    $('.modal-module__close-btn, .modal-module__overlay').on('click', function (e) {
      e.preventDefault();
      $('html').removeClass('hidden');
      $('.modal-module').removeClass('modal-module--open');

      setTimeout(function () {
        $('#youtube_player_container').empty();
        $('.modal-module__content').removeClass('modal-module__content--open');
      }, 200);
    });
  },

  controlForm: function () {
    function initGravityForm() {
      $('.gfield input, .gfield select, .gfield textarea').off('focus.gform blur.gform');
      $('.gfield input, .gfield select, .gfield textarea').on('focus.gform', function(){
        $(this).parents('.gfield').addClass('active');
      }).on('blur.gform', function(){
        if ($(this).val() === '') {
          $(this).parents('.gfield').removeClass('active');
        }
      });
      $('.gfield input, .gfield select, .gfield textarea').each(function() {
        if ($(this).val() === '') {
          $(this).parents('.gfield').removeClass('active');
        } else {
          $(this).parents('.gfield').addClass('active');
        }
      });
      $('.no-touch-device .cta').on('mouseenter mouseleave',function(e){
        let rect = this.getBoundingClientRect();
        let x = e.clientX - rect.left;
        let y = e.clientY - rect.top;
        $(this).find('.cta__hover').css({ left: x + "px", top: y + "px" });
      });
      $(window).trigger('resize');
    }

    document.addEventListener('gform/post_render', (event) => {
      initGravityForm();
    });

    initGravityForm();
  },

  initGSAP: function () {
    const clientsStripe = gsap.utils.toArray('.clients-module__stripe path'),
          contactStripe = gsap.utils.toArray('.contact-module__stripe path'),
          featuredWorkStripe = gsap.utils.toArray('.featured-work-module__stripe path'),
          heroStripe = gsap.utils.toArray('.hero-module__stripe path'),
          highlightStripe = gsap.utils.toArray('.highlight-module__stripe path'),
          legalStripe = gsap.utils.toArray('.legal-module__stripe path'),
          workGridStripeTop = gsap.utils.toArray('.work-grid-module__stripe.top path'),
          workGridStripeBottom = gsap.utils.toArray('.work-grid-module__stripe.bottom path');
    let matchMedia = gsap.matchMedia();

    matchMedia.add(
      {
        isDesktop: '(min-width: 981px)',
        isTablet: '(max-width: 980px) and (min-width: 761px)',
        isMobile: '(max-width: 760px) and (min-width: 541px)',
        isSmallMobile: '(max-width: 540px)',
      },
      (context) => {
        let { isDesktop, isTablet, isMobile } = context.conditions;

        clientsStripe.forEach((section) => {
          gsap.fromTo(section, {
            drawSVG: isMobile ? "10% 0%" : "0% 0%",
          },
          {
            drawSVG: isMobile ? "10% 90%" : "0% 100%",
            ease: "sine",
            scrollTrigger: {
              trigger: section,
              start: "top center",
              end: "bottom center",
              scrub: 1,
              invalidateOnRefresh: true,
            },
          });
        });

        contactStripe.forEach((section) => {
          gsap.fromTo(section, {
            drawSVG: isMobile ? "10% 0%" : "0% 0%",
          },
          {
            drawSVG: isMobile ? "10% 90%" : "0% 100%",
            ease: "sine",
            scrollTrigger: {
              trigger: section,
              start: "top center",
              end: "bottom center",
              scrub: 1,
              invalidateOnRefresh: true,
            },
          });
        });

        featuredWorkStripe.forEach((section) => {
          gsap.fromTo(section, {
            drawSVG: isMobile ? "10% 0%" : "0% 0%",
          },
          {
            drawSVG: isMobile ? "10% 90%" : "0% 100%",
            ease: "sine",
            scrollTrigger: {
              trigger: section,
              start: "top center",
              end: "bottom center",
              scrub: 1,
              invalidateOnRefresh: true,
            },
          });
        });

        heroStripe.forEach((section) => {
          gsap.fromTo(section, {
            drawSVG: isMobile ? "10% 0%" : "0% 0%",
          },
          {
            drawSVG: isMobile ? "10% 90%" : "0% 100%",
            ease: "sine",
            scrollTrigger: {
              trigger: section,
              start: "top center",
              end: "bottom center",
              scrub: 1,
              invalidateOnRefresh: true,
            },
          });
        });

        highlightStripe.forEach((section) => {
          gsap.fromTo(section, {
            drawSVG: isMobile ? "10% 0%" : "0% 0%",
          },
          {
            drawSVG: isMobile ? "10% 90%" : "0% 100%",
            ease: "sine",
            scrollTrigger: {
              trigger: section,
              start: "top center",
              end: "bottom center",
              scrub: 1,
              invalidateOnRefresh: true,
            },
          });
        });

        legalStripe.forEach((section) => {
          gsap.fromTo(section, {
            drawSVG: isMobile ? "10% 0%" : "0% 0%",
          },
          {
            drawSVG: isMobile ? "10% 90%" : "0% 100%",
            ease: "sine",
            scrollTrigger: {
              trigger: section,
              start: "top center",
              end: "bottom center",
              scrub: 1,
              invalidateOnRefresh: true,
            },
          });
        });

        workGridStripeTop.forEach((section) => {
          gsap.fromTo(section, {
            drawSVG: isMobile ? "10% 0%" : "0% 0%",
          },
          {
            drawSVG: isMobile ? "10% 90%" : "0% 100%",
            ease: "sine",
            scrollTrigger: {
              trigger: section,
              start: "top center",
              end: "bottom center",
              scrub: 1,
              invalidateOnRefresh: true,
            },
          });
        });

        workGridStripeBottom.forEach((section) => {
          gsap.fromTo(section, {
            drawSVG: isMobile ? "10% 0%" : "0% 0%",
          },
          {
            drawSVG: isMobile ? "10% 90%" : "0% 100%",
            ease: "sine",
            scrollTrigger: {
              trigger: section,
              start: "top center",
              end: "bottom center",
              scrub: 1,
              invalidateOnRefresh: true,
            },
          });
        });
      }
    );
  },

  initSwipers: function () {
    $('.awards-module__grid-gallery').each(function () {
      const $swiper = $(this);
      const $slides = $swiper.find('.awards-module__grid-gallery-item');
      let index = 0;
    
      function showSlide(i) {
        $slides.removeClass('active');
        $slides.eq(i).addClass('active');
      }
    
      showSlide(index);
    
      setInterval(() => {
        index = (index + 1) % $slides.length;
        showSlide(index);
      }, 2000);
    });

    $('.clients-module__list').each(function (index) {
      const navigationVar = 's' + Math.floor(Math.random() * 1000);
      $(this).find('.swiper-scrollbar').addClass(navigationVar);
      const swiper = new Swiper($(this)[0], {
        direction: 'horizontal',
        slidesPerView: 'auto',
        freeMode: true,
        grabCursor: true,
        simulateTouch: true,
        scrollbar: {
          el: '.swiper-scrollbar.' + navigationVar,
        },
      });
    });
  
    $('.services-module__grid-gallery').each(function () {
      const $swiper = $(this);
      const $slides = $swiper.find('.services-module__grid-gallery-item');
      let index = 0;
    
      function showSlide(i) {
        $slides.removeClass('active');
        $slides.eq(i).addClass('active');
      }
    
      showSlide(index);
    
      setInterval(() => {
        index = (index + 1) % $slides.length;
        showSlide(index);
      }, 2000);
    });

    $('.slider-block').each(function (index) {
      const navigationVar = 's' + Math.floor(Math.random() * 1000);
      $(this).find('.swiper-scrollbar').addClass(navigationVar);
      const swiper = new Swiper($(this)[0], {
        slidesPerView: 'auto',
        speed: 800,
        grabCursor: true,
        simulateTouch: true,
        scrollbar: {
          el: '.swiper-scrollbar.' + navigationVar,
          draggable: true,
        },
      });
    });

    $('.testimonials-module__grid').each(function (index) {
      const navigationVar = 's' + Math.floor(Math.random() * 1000);
      $(this).find('.swiper-btn').addClass(navigationVar);
      const swiper = new Swiper($(this)[0], {
        effect: 'slide',
        slidesPerView: 'auto',
        parallax: true,
        speed: 800,
        loop: true,
        grabCursor: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        simulateTouch: true,
        navigation: {
          prevEl: '.swiper-btn--previous.' + navigationVar,
          nextEl: '.swiper-btn--next.' + navigationVar,
        },
      });
    });

    $('.video-block__mobile').each(function (index) {
      const navigationVar = 's' + Math.floor(Math.random() * 1000);
      $(this).find('.swiper-scrollbar').addClass(navigationVar);
      const swiper = new Swiper($(this)[0], {
        slidesPerView: 'auto',
        speed: 800,
        grabCursor: false,
        simulateTouch: true,
        scrollbar: {
          el: '.swiper-scrollbar.' + navigationVar,
          draggable: true,
        },
      });
    });

    $('.no-touch-device .swiper-btn').on('mouseenter mouseleave',function(e){
      let rect = this.getBoundingClientRect();
      let x = e.clientX - rect.left;
      let y = e.clientY - rect.top;
      $(this).find('.swiper-btn__hover').css({ left: x + "px", top: y + "px" });
    });
  },

  getCopyrightYear: function () {
    const currentTime = new Date(),
      currentYear = currentTime.getFullYear();
    $('.footer .year').html(currentYear);
  },

  init: function () {
    this.checkTouchDevice();
    this.controlAnimation();
    this.checkDevice();
    this.controlHeader();
    this.controlFooter();
    this.controlMainMenu();
    this.controlCTA();
    this.controlHero();
    this.controlAwards();
    this.controlServices();
    this.controlWork();
    this.filterWork();
    this.controlModal();
    this.controlForm();
    this.initGSAP();
    this.initSwipers();
    this.getCopyrightYear();
  },
};

export default App;